// Importing react and external libraries
import React from 'react';

// Importing antd compoents
import { Tooltip } from 'antd';
import 'antd/es/tooltip/style/css';

// Importing antd icons
import { QuestionCircleOutlined } from '@ant-design/icons';

// Importing component style
import './style.scss';

const Label = ({ name, title }) => {
  return (
    <div className="label-wrapper">
      {name}
      {title && (<Tooltip className="label-icon" title={title}> <QuestionCircleOutlined /></Tooltip>)}
    </div>
  );
};

export default Label;
